// ================================
// IMPORTS
// ================================
import { ref, type Ref } from "vue"

// ================================
// TYPES & INTERFACES
// ================================

/**
 * Retour du composable useModalCompanyAddMember
 */
export type UseModalCompanyAddMemberReturn = {
    /** Visibilité de la modal d'ajout de membre */
    visible: Ref<boolean>
    /** Ouvre la modal */
    openModal: () => void
}

// ================================
// COMPOSABLE
// ================================

/**
 * Composable pour gérer la visibilité de la modal d'ajout de membre.
 * Le parent peut lier visible avec v-model:visible sur CompanyAddMemberDialog
 * et appeler openModal() au clic sur le bouton "Ajouter un membre".
 */
export function useModalCompanyAddMember(): UseModalCompanyAddMemberReturn {
    const visible = ref(false)

    function openModal() {
        visible.value = true
    }

    return {
        visible,
        openModal,
    }
}
